export default "__VITE_ASSET__CRHlJEzD__"